import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { ApiResponse, HttpResponse } from 'app/types-shared';
import { endpoint } from './endpoints';

export const api = {

  getOptions: async (component, loadOptionsParams): Promise<HttpResponse<ApiResponse<any>>> => {
    return new RemoteData(endpoint.options[component]).resource<HttpResponse<ApiResponse<any>>>()
      .filter({
        ...loadOptionsParams
      }).all();
  },
    
  saveSettings: async (profileData: any) => {

    return new RemoteData(endpoint.currentUser)
      .resource<HttpResponse<ApiResponse<any>>>()
      .save(profileData);
  },

  changePassword: async (passwordData: any) => {
      return new RemoteData(endpoint.changePassword)
        .resource<HttpResponse<ApiResponse<any>>>()
        .create(passwordData);
      }
    
};
